<template>
  <b-form-select
    v-model="selected"
    :options="steps"
    size="sm"
    class="selectZone"
    @change="changeWorkstation"
  />
</template>

<script>
import { bus } from '../../core/utils/bus.js'


export default {
  name: 'WorkstationSelector',
  props: ['selected'],
  data: function() {
    return {
      steps: [
        { value: 'ALL', text: 'Toutes les zones' },
        { value: 'En Stock', text: 'En Stock' },
        { value: 'Att. com', text: 'Attente Commande' },
        { value: 'Commandé', text: 'Commandé' }
      ]
    }
  },
  methods: {
    changeWorkstation: function(step) {
      this.goTo('/andonkanban/' + step)
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.flexList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  list-style: none;
  margin: 0;
  padding: 0;
}
.selectZone {
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/andon/WorkstationSelector.vue